export default __webpack_public_path__ + "static/media/a5.afbb32c2.webp";